module.exports = __webpack_public_path__ + "img/horizontal_3_3_7016.60194b29.png";